/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AddFamilyMemberPayload } from 'api/actions/add-family-member/add-family-member-payload';
import { AddFamilyMemberPathParameters } from 'api/actions/add-family-member/add-family-member-path-parameters';
import { AddFamilyMemberResponse } from 'api/actions/add-family-member/add-family-member-response';

type AddFamilyMemberQueryParameters = Record<string, any>;

/**
 * The path of the AddFamilyMember action.
 */
export const addFamilyMemberActionPath = new SweetPath<keyof AddFamilyMemberPathParameters>(
  '/user/family/members/add',
  { path: '{param}' }
);

/**
 * Creates a contextualized AddFamilyMember actions.
 */
export default function createAddFamilyMemberAction(axios: AxiosInstance) {
  return function addFamilyMemberAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: AddFamilyMemberQueryParameters;
    payload: AddFamilyMemberPayload;
  }) {
    const path = addFamilyMemberActionPath.original;

    return axios.post<AddFamilyMemberResponse, AddFamilyMemberResponse, AddFamilyMemberPayload>(path, payload);
  };
}
